// src/utils/permissions.js
//
// What the logged-in user may do. Client permissions come from the server
// (/api/auth/me -> permissions, set by superadmins in Settings > Roles).
// Internal admins have every client permission.
//
// This only decides what to SHOW. The server checks the same permission on
// every request, so hiding a link is tidiness, not security.
//
// Keys: fleet.view, alerts.view, alerts.push, devices.control,
//       support.use, billing.view, users.manage

// If the server didn't send a list (shouldn't happen: login and
// /api/auth/me both include it), show only the dashboard. Guessing more
// would show pages the server then refuses.
const FALLBACK = ['fleet.view'];

export function can(user, permission) {
  if (!user) return false;
  if (user.user_type === 'admin') return true;
  const list = Array.isArray(user.permissions) ? user.permissions : FALLBACK;
  return list.includes(permission);
}
